/* global URLSearchParams */
/**
 * News & Stories — Category Pills and Current Filter Display
 *
 * Reads category data and Search & Filter query ID from a
 * <script type="application/json" id="cmnh-news-filter-data"> data block
 * so this file stays static and CSP-hashable.
 *
 * @package CMNBaseTheme
 */

/* global jQuery, setTimeout */

jQuery(document).ready(function ($) {
    'use strict';

    var dataEl = document.getElementById('cmnh-news-filter-data');
    if (!dataEl) {
        return;
    }

    var config;
    try {
        config = JSON.parse(dataEl.textContent.trim());
    } catch (e) {
        return;
    }

    var categoryData = config.categories || {};
    var queryId = config.queryId;

    function resolveSearchFilterQuery() {
        var queries = window.searchAndFilter?.frontend?.queries;
        if (!queries || typeof queries.get !== 'function') {
            return undefined;
        }
        if (queryId == null || queryId === '') {
            return undefined;
        }
        return (
            queries.get(queryId) ??
            queries.get(Number(queryId)) ??
            queries.get(String(queryId))
        );
    }

    var query = resolveSearchFilterQuery();

    function getCategoryParamValue() {
        var params = new URLSearchParams(window.location.search);
        var direct = params.get('_category');
        if (direct !== null && String(direct).trim() !== '') {
            return direct;
        }
        var keys = Array.from(params.keys());
        var i;
        for (i = 0; i < keys.length; i++) {
            var k = keys[i];
            if (k.indexOf('_') !== 0) {
                continue;
            }
            if (k === '_s' || k === '_wpnonce' || k === '_ajax_nonce') {
                continue;
            }
            var v = params.get(k);
            if (!v || !String(v).trim()) {
                continue;
            }
            var slugs = String(v).split(',').map(function (s) {
                return s.trim();
            });
            var hit = slugs.some(function (s) {
                return Object.prototype.hasOwnProperty.call(categoryData, s);
            });
            if (hit) {
                return v;
            }
        }
        return null;
    }

    function getUrlParams() {
        var params = new URLSearchParams(window.location.search);
        var rawSearch = params.get('_s') || params.get('s') || '';
        var search = typeof rawSearch === 'string' ? rawSearch.trim() : '';
        return {
            search: search || null,
            category: getCategoryParamValue()
        };
    }

    function displayCurrentFilters() {
        var $container = $('.filter-utility .current-filters .category-pills');
        if (!$container.length) {
            return;
        }
        $container.empty();

        var urlParams = getUrlParams();
        var search = urlParams.search;
        var category = urlParams.category;
        var hasFilters = false;

        if (search) {
            hasFilters = true;
            $container.append(
                $('<div class="category-pill current-filter-pill"></div>').text(search)
            );
        }

        if (category) {
            var categories = String(category).split(',');

            categories.forEach(function (catSlug) {
                catSlug = catSlug.trim();

                if (categoryData[catSlug]) {
                    hasFilters = true;
                    var cat = categoryData[catSlug];
                    var $pill = $('<div class="category-pill current-filter-pill"></div>').text(cat.name);
                    $container.append($pill);
                }
            });
        }

        if (!hasFilters) {
            $container.append(
                $('<div class="category-pill current-filter-pill default"></div>').text('All News & Stories')
            );
        }
    }

    if (query && query.getAttribute('resultsDynamicUpdate') === 'yes') {
        query.on('get-results/finish', function () {
            setTimeout(function () {
                displayCurrentFilters();
            }, 150);
        });
    }

    displayCurrentFilters();
});
